import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { Emoji } from './Emoji';
type CountdownProps = {
  label: string;
  note?: string;
};
export function Countdown({
  label,
  note
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    suffix: 'hs'
  }, {
    value: minutes,
    suffix: 'min'
  }, {
    value: seconds,
    suffix: 'seg'
  }];
  return <div className="text-center" data-id="element-63" data-mp="3c1mh8fg22fwl">
      <p className="inline-flex flex-wrap items-center justify-center gap-2 font-display text-[13px] font-bold uppercase tracking-[0.16em] text-red-700 sm:text-lg" data-id="element-64" data-mp="3c0kxlmkz4l39">
        <Emoji symbol="⏰" data-id="element-65" data-mp="324rne9uq93on" />
        {label}
      </p>
      <div className="mt-4 flex items-start justify-center gap-2 sm:gap-3" role="timer" aria-live="off" aria-label={`Quedan ${hours} horas, ${minutes} minutos y ${seconds} segundos`} data-id="element-66" data-mp="3262rkas34dga">
        {units.map((unit, index) => <React.Fragment key={unit.suffix} data-id="element-67" data-mp="15awiumspo2oz" data-mpi={index}>
            <div className="min-w-[72px] rounded-2xl border border-red-200 bg-white px-3 py-3 shadow-card sm:min-w-[104px] sm:px-5 sm:py-4" data-id="element-68" data-mp="y16kj8y5q3q6">
              <span className="block font-display text-[clamp(1.6rem,7vw,3rem)] font-black leading-none tabular-nums text-red-600" data-id="element-69" data-mp="t1agxatdgeb5">
                {unit.value}
              </span>
              <span className="mt-1.5 block text-[10px] font-semibold uppercase tracking-widest text-ink-400 sm:text-[11px]" data-id="element-70" data-mp="12rmxkry2fnc0">
                {unit.suffix}
              </span>
            </div>
            {index < units.length - 1 ? <span className="pt-3 font-display text-xl text-red-300 sm:pt-5 sm:text-3xl" data-id="element-71" data-mp="a528xz8z5pc5">
                :
              </span> : null}
          </React.Fragment>)}
      </div>
      {note ? <p className="mx-auto mt-5 max-w-md text-[13px] font-medium text-ink-500 sm:text-sm" data-id="element-72" data-mp="k3hxpvkj4mih">
          {note}
        </p> : null}
    </div>;
}